import { Button, Tooltip } from "@showitinc/showit-wc";
import React, { useEffect, useState } from "react";
import UIActions from "../actions/UIActions";
import AppConfig from "../config/app";
import AppConstants from "../constants/AppConstants";
import LocalStorageService from "../service/LocalStorageService";
import { useAccountState } from "../hooks/query/useAccount";
import { shouldShowTutorialVideo } from "../utils/TutorialVideoUtils";
import uiPrefix from "../utils/UiPrefixUtils";
import ChatButton from "./ChatButton";
import TutorialVideoModal from "./TutorialVideoModal";
import styles from "./InfoSection.module.css";

const InfoSection = ({ width }) => {
  const user = useAccountState();
  const [showVideo, setShowVideo] = useState(false);

  // Show the tutorial once for newer users who haven't seen it yet.
  useEffect(() => {
    if (!shouldShowTutorialVideo(user)) return;
    setShowVideo(true);
    LocalStorageService.set(AppConstants.TUTORIAL_VIDEO_SEEN_KEY, true);
  }, [user]);

  const getChatButton = () => {
    if (AppConfig.demoMode) {
      return (
        <ChatButton
          onClick={UIActions.openSignupModal}
          messages={user.get("messages", 0)}
          title="Ask a Question"
        />
      );
    }
    return <ChatButton messages={user.get("messages", 0)} title="Ask a Question" />;
  };

  const helpDocs = () => {
    window.open("https://learn.showit.com", "_blank");
  };

  return (
    <div className={styles.infoSection} data-intercom-target="info section">
      <div
        data-e2e={uiPrefix("get-help-btn")}
        className={`${styles.labelStyle} ${uiPrefix("get-help-btn")}`}
        onClick={() => window.intercom?.("show")}
      >
        Get Help
      </div>
      <Tooltip delay={10} position="top-center" variant="legacy">
        <Button
          variant="icon"
          iconPrefix="helpVideo"
          iconSize="20"
          onClick={() => setShowVideo(true)}
          className={styles.helpVideoButton}
        />
        <span slot="content">Watch Tutorial</span>
      </Tooltip>
      <Tooltip delay={10} position="top-center" variant="legacy">
        <Button
          variant="icon"
          iconPrefix="helpDocs"
          iconSize="20"
          onClick={helpDocs}
          className={styles.helpDocsButton}
        />
        <span slot="content">View Help Docs</span>
      </Tooltip>
      {getChatButton()}
      <TutorialVideoModal show={showVideo} onHide={() => setShowVideo(false)} />
    </div>
  );
};

export default InfoSection;
